$('.js-openZoomModal').click(function (e) {
   e.preventDefault();
   e.stopPropagation();
   var elToShow = $(this).parent().find('.zoomModal');
   $(elToShow)
       .clone()
       .appendTo('body')
       .show()
       .click(function () {
           $('body > .zoomModal').remove();
       })
       .find('.js-closeZoomModal').click(function () {
            $('body > .zoomModal').remove();
       });
});

$(document).keyup(function (e) {
 if(e.keyCode === 27 || e.keyCode === 8 ){
     $('body > .zoomModal').remove();
 }
});
